import React, { Fragment, useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../../components/hero';
import Destination from '../../components/Destination';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import WalletStats from '../../components/WalletStats';

import hero1 from '../../images/slider/slide-3.b6d0f1ef.jpg';
import hero2 from '../../images/slider/slide-1.439651a1.jpg';
import hero3 from '../../images/slider/slide-2.c832719f.jpg';

const HomePage = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

    useEffect(() => {
        // Apply zoom-out fix by default on mobile after login
        if (isLoggedIn && window.innerWidth <= 768) {
            const meta = document.querySelector('meta[name="viewport"]');
            if (meta) {
                meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
            }
        }
    }, [isLoggedIn]);

    const handleSuccess = () => {
        setRefreshKey((prevKey) => prevKey + 1); // Change key to force re-render
    };

    return (
        <Fragment key={refreshKey}>  {/* Set key here to force full page re-render */}
            <Navbar />
            {isLoggedIn && <WalletStats />}
            <Hero
                heroClass={'hero-style-1'}
                heroImg1={hero1}
                heroImg2={hero2}
                heroImg3={hero3}
                onSuccess={handleSuccess} // Pass callback to Hero
            />
            <Destination />
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default HomePage;
